import { createThemeCompiler } from '../../../utils';

export const fileUploadThemeCompiler = createThemeCompiler(({ palette, borderRadius, stroke }) => ({
    fileUpload: {
        colors: {
            backgroundColor: palette.transparent,
            foregroundColor: palette.neutralPrimary,
            borderColor: palette.neutralTertiary,
            item: {
                backgroundColor: palette.transparent,
                foregroundColor: palette.neutralPrimary
            },
            tile: {
                backgroundColor: palette.themePrimary,
                foregroundColor: palette.white
            }
        },
        composites: {
            borderRadius: borderRadius.curvedMedium,
            borderWidth: stroke.thin
        }
    }
}));
